import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { v4 as createUuid } from 'uuid';
import { OnlineStatusEnum } from '../../../../../../../../types/src/common/enum/online-status.enum';
import { UserGridItemObject } from '@it2go/types';
import { UserService } from '../../../service/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AvatarComponent } from '../../../../shared/components/kit/avatar/avatar.component';
import { PersonInitialsPipe } from '../../../../shared/pipes/personInitials';
import { UserMainInfoComponent } from '../user-main-info/user-main-info.component';

@Component({
    selector: 'app-user-card',
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.scss'],
    imports: [
        AvatarComponent,
        NgClass,
        PersonInitialsPipe,
        UserMainInfoComponent,
    ],
})
export class UserCardComponent {
    private readonly userService = inject(UserService);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    @Input() user: UserGridItemObject | null = null;

    openChat(): void {
        return;
    }

    sendPushNotification(): void {
        if (!this.user) return;
        this.userService
            .sendPushNotification({
                id: createUuid(),
                user_id: this.user.id,
            });
    }

    openDetail() {
        if (!this.user?.id) return;
        this.router.navigate([this.user.id], { relativeTo: this.route });
    }

    protected readonly OnlineStatusEnum = OnlineStatusEnum;
}
